import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import NewsTimeline from "./components/NewsTimeline";
import Channels from "./components/Channels";
import Guide from "./components/Guide";
import FakeWarning from "./components/FakeWarning";
import Trust from "./components/Trust";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main className="bg-background-50 text-foreground-900">
        <Hero />
        <Guide />
        <NewsTimeline />
        <Channels />
        <FakeWarning />
        <Trust />
        <Faq />
      </main>
      <Footer />
    </>
  );
}